import { useEffect, useState } from 'react';
import { withFormik } from 'formik';
import _isEmpty from 'lodash/isEmpty';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import { VERSIONS } from 'constants/versions';
import { Modal } from 'components';
import GiftsList from 'components/gifts-table/GiftsList';
import GiftsFilter from 'components/gifts-table/GiftsList/GiftsFilter';
import { getProductsById } from 'services/api/products';
import TableWelcomeMessage from 'components/gifts-table/TableWelcomeMessage';
import { GiftItem, TableHero } from 'components/gifts-table';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { resetExternalGiftTable } from 'store/actions/externalGiftTable';
import ClosedTableMessage from 'components/gifts-table/ClosedTableMessage';
import { MODES } from 'components/gifts-table/GiftsList/GiftItem/config';
import { isTableOpen } from 'util/giftTable';
import { showErrorResponseModal } from 'store/actions/commons';
import _get from 'lodash/get';
import { isMobile } from 'util/screen';
import styles from './styles.module.scss';

const mapPropsToValues = ({ selectedCategory = {}, giftParams = {} }) => ({
  selectedCategory: selectedCategory.id || '',
  filterCategory: giftParams.category || 'Sugerencias'
});

function GuestLanding({
  dispatch,
  tableInfo,
  externalGiftTableProducts,
  shoppingCartProducts,
  fetchExternalGiftTableProducts,
  addShoppingCartProduct,
  removeShoppingCartProduct,
  changeProductsPage,
  fetchShoppingCart,
}) {
  const { eventId } = useParams();
  const history = useHistory();
  const [showProduct, setShowProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  /* const [giftTableProduct, setGiftTableProduct] = useState({});
  const [productosid, setProductosid] = useState([]);
  const [brands, setBrands] = useState([]);
  const [listaProduct,setListaProduct] = useState('');
  const [loading, setLoading] = useState(true); */

  const handleAddProduct = async (product) => {
    const response = await addShoppingCartProduct(product);                 // Agrega al carrito de comparas mesa regalos
    //  console.log("Agregamdo producto al carrito. Objeto producto:",product);
    setShowProduct(false);
    !response && dispatch(fetchShoppingCart({ tableId: tableInfo.id }));
    //  !response && dispatch(showErrorResponseModal('Revisando login . . .'));
    return response;
  };

  const handleDeleteProduct = async (product) => {
    const response = await removeShoppingCartProduct(product);
    setShowProduct(false);
    !response && dispatch(fetchShoppingCart({ tableId: tableInfo.id }));
    !response && dispatch(showErrorResponseModal('Intenta más tarde'));
    return response;
  };

  const handlePaginationChange = (page) => {
    changeProductsPage(page);
  };

  const handleClickProduct = (item) => {
    setShowProduct(true);
    setSelectedProduct({
      ...item,
      images: [{ id: 1, order: 1, original: item.image }]
    });
  };

  useEffect(() => {
    if (!eventId) history.push('/');
  }, [eventId, history]);

  useEffect(() => {
    if (eventId)
      dispatch(
        fetchGiftTableInfo({
          id: eventId,
          isExternal: true
        })
      );
  }, [eventId]);

  useEffect(() => {
    if (!_isEmpty(tableInfo)) {
      console.log('....: ', tableInfo)
      fetchExternalGiftTableProducts(tableInfo);
    }
  }, [tableInfo]);

  useEffect(() => {
    if (shoppingCartProducts.find((x) => x.id === selectedProduct.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedProduct, shoppingCartProducts]);

  useEffect(() => () => dispatch(resetExternalGiftTable()), []);

  useEffect(()=>{
    if(externalGiftTableProducts?.results?.success){
      console.log('externalGiftTableProducts',externalGiftTableProducts);
    }
  },[externalGiftTableProducts])


  // Inicia codigo para poner filtro de mi mesa nuevo desarrollo
  /* useEffect(() => {
    if (externalGiftTableProducts.results?.allElements) {
      const allIdproducts = externalGiftTableProducts.results.allElements.map(Productos => Productos);
      setProductosid(allIdproducts);
    }
  }, [externalGiftTableProducts.results]);
  console.log('idproductos',productosid);

  useEffect(() => {
    let isMounted = true;

    const obtenerBrands = async () => {
      try {
        setLoading(true); // Establecer el estado de carga a true al iniciar la obtención de las marcas

        const uniqueBrands = [];
        const arrayBrands = [];

        const promises = productosid.map(async (productId) => {
          try {
            const productData = await getProductsById([productId]);

            if (isMounted) {
              const detail = productData?.data?.[0];
              const categoria = detail?.categories?.[0]?.[detail.categories[0].length - 1];
              const nombrecategoria = categoria?.name;

              if (detail && nombrecategoria) {
                const newDataArray = {
                  id: detail.id,
                  description: detail.description,
                  item: detail.id,
                  title: detail.title,
                  image: detail.pictures?.[0]?.thumbnail || '',
                  msrp: detail.pricing?.list_price,
                  price: detail.pricing?.sales_price,
                  c_descuento: detail.pricing?.percentage_discount,
                  product_id: detail.id,
                  stock: detail.stock,
                  review: String(detail.rating?.average_score),
                  total_review: detail.rating?.total_reviews,
                  status: detail.status || detail.is_active,
                  categories: nombrecategoria,
                  seller: detail.seller || [],
                  variant_id: detail.variant_id,
                  variant_sku: detail.variant_sku,
                  sku: detail.sku,
                  ean: detail.ean,
                  division: detail.division,
                  variations: detail.variations,
                  brand: detail.brand,
                };

                arrayBrands.push(newDataArray);

                if (!uniqueBrands.includes(nombrecategoria)) {
                  uniqueBrands.push(nombrecategoria);
                }
              }
            }
          } catch (error) {
            console.error(`Error al obtener la categoría para el producto con ID ${productId}`);
          }
        });

        await Promise.all(promises);

        if (isMounted) {
          setBrands(uniqueBrands);
          setListaProduct(arrayBrands);
        }
      } catch (error) {
        console.error('Error al obtener las marcas de los productos', error);
      } finally {
        if (isMounted) {
          setLoading(false); // Establecer el estado de carga a false una vez finalizada la obtención de las marcas
        }
      }
    };

    obtenerBrands();

    return () => {
      isMounted = false;
    };
  }, [externalGiftTableProducts]);

  console.log('brands',brands);
  console.log('listaProduct',listaProduct);

  const handleFilterByBrand = (selectedBrand) => {
    console.log('selectedBrand', selectedBrand);

    // Verificar si 'data' tiene la estructura correcta
    if (externalGiftTableProducts?.results?.list && Array.isArray(externalGiftTableProducts.results.list)) {
      // Si no hay una marca seleccionada, mostrar todos los productos
      if (!selectedBrand) {
        setGiftTableProduct({});
      } else {
        // Filtrar los productos según la marca seleccionada
        const filteredList = listaProduct.filter(product => product.categories === selectedBrand);
        const filteredProducts = {
          ...externalGiftTableProducts,
          results: {
            ...externalGiftTableProducts.results,
            list: filteredList
          }
        };
        setGiftTableProduct(filteredProducts);
      }
    }
  }; */
  // console.log('giftTableProduct',giftTableProduct);
  // Finaliza codigo para poner filtro de mi mesa nuevo desarrollo

  const [tabOk, setTabOk] = useState(false)
  useEffect(()=>{
    if(tableInfo?.id){
      setTabOk(true)
    }
  },[tableInfo])

  return (
    <section className={styles.TableAdmin}>
      <TableHero
        image={tableInfo?.image}
        typeId={tableInfo?.type?.id}
        eventName={tableInfo?.type?.name}
        name={tableInfo?.name}
        date={tableInfo?.date}
        readOnly
      />
      <TableWelcomeMessage
        onlyView
        value={tableInfo?.welcome_message}
      />
      <Container className="mb-5">
        <Row>
          <Col xs={12} lg={3}>
            {/* seccion filtrado cuando es mesa */}
            {/* <div>
              {(loading && brands.length > 0) ? (
                  <p>Cargando Categorías...</p>
              ) : (
                  <>
                    {brands.length > 0 ? (
                        <GiftsFilter brands={brands} onFilter={handleFilterByBrand} />
                    ) : null}
                    {brands.length === 0 ? (
                        <p>No hay categorías disponibles.</p>
                    ) : null}
                  </>
              )}
            </div> */}
          </Col>
          <Col xs={12} lg={11}>
            {!isTableOpen(tableInfo) && tabOk ? (
              <ClosedTableMessage />
            ) : (
              // lalo
              <GiftsList
                title="Mesa de regalos"
                /* data={Object.keys(giftTableProduct).length !== 0 ? giftTableProduct : externalGiftTableProducts}
                selected={Object.keys(giftTableProduct).length !== 0 ? _get(giftTableProduct, 'results.allElements', []) : _get(shoppingCartProducts, 'results.allElements', [])} */
                data={externalGiftTableProducts}
                selected={shoppingCartProducts}
                onClickItem={handleClickProduct}
                onAddItem={handleAddProduct}
                onUpdateItem={handleAddProduct}
                onDeleteItem={handleDeleteProduct}
                onPaginationChange={handlePaginationChange}
                defaultMode="guest"
                showFilterByOrder={false}
              />
            )}
          </Col>
        </Row>
      </Container>
      <Modal
        show={showProduct}
        onClose={() => {
          setShowProduct(false);
        }}
        withActionButtons={false}
        variant="completed"
        variantOnlyInMobile
        dialogClassName={`${styles.modalDialog}`}
        containerClassName=""
      >
        <GiftItem
          item={selectedProduct}
          id={1}
          type={!isMobile?'bigDetails':'mobileDetails'}
          stockMock
          selected={isSelected}
          version={VERSIONS.V2}
          onUpdateGift={handleAddProduct}
          onAddGift={handleAddProduct}
          onDeleteGift={handleDeleteProduct}
          onCloseSuccessMessage={() => {}}
          giftTableId={eventId}
          mode={MODES.GUEST}
        />
      </Modal>
    </section>
  );
}

export default withFormik({ mapPropsToValues })(GuestLanding);
